import API from "./api";
import router from "@/router";

export default {
    fetchDataConsentTrainer() {
       
        return API().get(`DataConsentTrainer/count/${router.currentRoute.params.id}`);
      },
      fetchAllTrainerData() {
       
        return API().get(`DataConsentTrainer/all/${router.currentRoute.params.id}`);
      },
}